import { request } from './client';
import type {
  ThreadAccountSchedule,
  ThreadAccountScheduleUpdateRequest,
} from './types';

export function getSchedule(threadAccountId: number) {
  return request<ThreadAccountSchedule>(
    `/api/thread-account-schedules/thread-account/${threadAccountId}`,
    { method: 'GET' }
  );
}

export function upsertSchedule(
  threadAccountId: number,
  payload: ThreadAccountScheduleUpdateRequest
) {
  return request<ThreadAccountSchedule>(
    `/api/thread-account-schedules/thread-account/${threadAccountId}`,
    { method: 'PUT', body: payload }
  );
}
